import { defineMessages } from "react-intl";

export const marketingManagerMessages = defineMessages({
  title: {
    id: "marketingManager.title",
    defaultMessage: "Marketing",
  },
  subtitle: {
    id: "marketingManager.subtitle",
    defaultMessage: "Manage the promotional image displayed on the Backoffice login screen.",
  },
  // Validity section
  validityTitle: {
    id: "marketingManager.validity.title",
    defaultMessage: "Validity",
  },
  validityDescription: {
    id: "marketingManager.validity.description",
    defaultMessage: "Set the date range during which the loaded image will be displayed.",
  },
  startDate: {
    id: "marketingManager.validity.startDate",
    defaultMessage: "Start date",
  },
  endDate: {
    id: "marketingManager.validity.endDate",
    defaultMessage: "End date",
  },
  redirectUrl: {
    id: "marketingManager.validity.redirectUrl",
    defaultMessage: "Redirect URL",
  },
  redirectUrlPlaceholder: {
    id: "marketingManager.validity.redirectUrlPlaceholder",
    defaultMessage: "https://example.com/destination-page",
  },
  // Desktop section
  desktopTitle: {
    id: "marketingManager.desktop.title",
    defaultMessage: "Desktop",
  },
  desktopResolution: {
    id: "marketingManager.desktop.resolution",
    defaultMessage: "The image must have a resolution of 700 x 462 px.",
  },
  desktopFormats: {
    id: "marketingManager.desktop.formats",
    defaultMessage: "Maximum one image. Valid formats: png, jpeg, jpg.",
  },
  // Mobile section
  mobileTitle: {
    id: "marketingManager.mobile.title",
    defaultMessage: "Mobile",
  },
  mobileResolution: {
    id: "marketingManager.mobile.resolution",
    defaultMessage: "The image must have a resolution of 322 x 298 px.",
  },
  mobileFormats: {
    id: "marketingManager.mobile.formats",
    defaultMessage: "Maximum one image. Valid formats: png, jpeg, jpg.",
  },
  // Buttons
  save: {
    id: "marketingManager.save",
    defaultMessage: "Save",
  },
  back: {
    id: "marketingManager.back",
    defaultMessage: "Back",
  },
  // Validation messages
  validationDesktopRequired: {
    id: "marketingManager.validation.desktopRequired",
    defaultMessage: "Desktop image is required.",
  },
  validationMobileRequired: {
    id: "marketingManager.validation.mobileRequired",
    defaultMessage: "Mobile image is required.",
  },
  validationEndDateAfterStartDate: {
    id: "marketingManager.validation.endDateAfterStartDate",
    defaultMessage: "End date must be after start date.",
  },
  validationInvalidUrl: {
    id: "marketingManager.validation.invalidUrl",
    defaultMessage: "Please enter a valid URL (must start with http:// or https://).",
  },
  // Feedback
  saveSuccess: {
    id: "marketingManager.saveSuccess",
    defaultMessage: "Changes saved successfully.",
  },
  saveError: {
    id: "marketingManager.saveError",
    defaultMessage: "An error occurred while saving. Please try again.",
  },
});
